import { reportLinkClick } from '../analytics';
import { getLinkModule } from '../helpers';
import AuthService from '../services/AuthService';

const authService = new AuthService();

export default function useLogout() {
  const linkModule = getLinkModule();

  return async () => {
    reportLinkClick('Logout', '/account/logout', linkModule);
    await authService.logout();
  };
}
